import type { QueryClient } from "@tanstack/react-query";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import { findNewestPageIndex } from "web_myplann/Chat/Helpers/Messages/chatMessagesCache";
import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";
import type { ChatMessagesCache } from "web_myplann/Chat/Types/chatMessagesPage";

export const getUnsentChatMessages = (
	queryClient: QueryClient,
	conversationId: number | null,
	keptClientIds: ReadonlySet<string>,
): ChatMessageView[] => {
	const cache = queryClient.getQueryData<ChatMessagesCache>(
		ChatKeys.messages(conversationId),
	);
	if (!cache) return [];

	const newestPageIndex = findNewestPageIndex(cache);
	if (newestPageIndex === -1) return [];

	return (cache.pages[newestPageIndex]?.items ?? []).filter(
		(item) =>
			item.clientId !== undefined &&
			(item.status === "failed" || keptClientIds.has(item.clientId)),
	);
};
